"use client";

import { c as _c } from "react/compiler-runtime";
import LatestActivity from "@/components/latest-activity/LatestActivity";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
import { Col, Container, Row } from "react-bootstrap";
export default function NFTActivityPage() {
  const $ = _c(1);
  useSetTitle("NFT Activity | Network");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <main className={styles.main}><Container fluid={true} className={styles.leaderboardContainer}><Row><Col><LatestActivity page={1} pageSize={50} showMore={true} /></Col></Row></Container></main>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}